import {MatterType} from './matter-type';
import {UnityConnectTransaction} from './unity-connect-transaction';
import {Utils} from '../utils';

export class MatterSummary {
    lawFirm: string;
    matterId: number;
    matterType: MatterType;
    matterTypeName: string;
    matterCloseDate: string;
    matterAddressOrDescription: string;
    transactions: UnityConnectTransaction[] = [];

    get lawFirmShort(): string {
        return Utils.truncateStringForDisplay(this.lawFirm, 30, '...');
    }
}
